import React, { memo, type ReactNode } from 'react';
import classnames from 'classnames';
import { useSignal } from '@funtech-int/rival-react';
import { ReadonlySignal } from '@funtech-int/rival';

import styles from './Select.module.css';

interface SelectOption {
    value: string;
    label: string;
    icon?: ReactNode;
}

interface SelectOptionItemProps {
    option: SelectOption;
    index: number;
    isSelected: boolean;
    optionId: string;
    signal: ReadonlySignal<number>;
    onMouseEnter: () => void;
    onClick: (e: React.MouseEvent) => void;
}

export const SelectOptionItem = memo(
    ({
        option,
        index,
        isSelected,
        signal,
        optionId,
        onMouseEnter,
        onClick,
    }: SelectOptionItemProps) => {
        const highlightedIndex = useSignal(signal);

        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <li
                id={optionId}
                className={classnames(styles.option, {
                    [styles.selected]: isSelected,
                    [styles.highlighted]: highlightedIndex === index,
                })}
                role="option"
                aria-selected={isSelected}
                onMouseEnter={onMouseEnter}
                tabIndex={-1}
                onClick={onClick}
            >
                {option.icon && (
                    <span className={styles.optionIcon} aria-hidden="true">
                        {option.icon}
                    </span>
                )}
                {option.label}
            </li>
        );
    }
);
